<div class="info card">
  <fa-icon class="info__icon" [icon]="iconInfo"></fa-icon>
  <div class="info__container-info">
    <h4 [innerHTML]="'EX_RUN_WAIT_EVALUATION' | translate"></h4>
  </div>
</div>
